module.exports = {
    default: 'en',
    languages: {
        en: {
            path: 'en',
            name: 'en'
        }
    }
};